import script from "./StatusLandingPage.vue?vue&type=script&setup=true&lang=js"
export * from "./StatusLandingPage.vue?vue&type=script&setup=true&lang=js"

import "./StatusLandingPage.vue?vue&type=style&index=0&id=e862beb0&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e862beb0"]])

export default __exports__